import {connect} from "react-redux";
import TechComplainsList from "./TechComplainsList";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import {centralTechComplainRaiseList, centralTechList, changeCentralTech} from "../../../../services/redux/fileComplain/action";
import {getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    centralTechComplainRaiseListResponse: state.fileComplainReducer.centralTechComplainRaiseListResponse,
    centralTechListResponse: state.fileComplainReducer.centralTechListResponse,
    changeCentralTechResponse: state.fileComplainReducer.changeCentralTechResponse,
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            centralTechComplainRaiseList,
            centralTechList,
            changeCentralTech,
            getRmTicketsFilterDropDown,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TechComplainsList);
